import { money } from 'services/graphql/fragments/Fragments';
import { AnalyticsFragment } from 'services/graphql/fragments/VxlFragments';
import { gql } from 'urql';

const GooglePayFundingOptions = gql`
  query GooglePayFundingOptions {
    googlePayFundingOptions {
      __typename
      ... on GooglePayFundingOptionsSuccess {
        minAmount {
          ...money
        }
        maxAmount {
          ...money
        }
        limitInfo
        transferLimitErrorMessage
        options {
          id
          title
          amount {
            ...money
          }
        }
        cardNetworks
        gateway
        gatewayMerchantId
        allowedAuthMethods
        dailyLimitInformation {
          title
          message1
          message2
        }
        monthlyLimitInformation {
          title
          message1
          message2
        }
        disclaimer
      }
      ... on GooglePayFundingOptionsNotEligible {
        title
        message
        button {
          id
          buttonText
          buttonStyle
          buttonOnClick {
            __typename
            ... on SDBackNavigationAction {
              analyticsEvent {
                ...analytics
              }
            }
          }
        }
      }
      ... on GooglePayFundingOptionsError {
        code
        title
        message
      }
    }
  }
  ${money}
  ${AnalyticsFragment}
`;

export default GooglePayFundingOptions;
